module.exports = "<igo-context-list\r\n  igoContextListBinding\r\n  (edit)=\"editContext()\"\r\n  (manageTools)=\"manageTools()\"\r\n  (managePermissions)=\"managePermissions()\">\r\n</igo-context-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/context-manager-tool/context-manager-tool.component.html
// module id = 1109
// module chunks = 0